import "src/framework/structural_components/hbox_vbox.css.ts.vanilla.css!=!../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/framework/structural_components/hbox_vbox.css.ts.vanilla.css\",\"source\":\"Ll8xcnNsOHFqMCB7CiAgZGlzcGxheTogZmxleDsKfQouXzFyc2w4cWoxIHsKICBmbGV4LWRpcmVjdGlvbjogcm93Owp9Ci5fMXJzbDhxajIgewogIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47Cn0KLl8xcnNsOHFqMyB7CiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7Cn0KLl8xcnNsOHFqNCB7CiAgYWxpZ24taXRlbXM6IGZsZXgtZW5kOwp9Ci5fMXJzbDhxajUgewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7Cn0KLl8xcnNsOHFqNiB7CiAgYWxpZ24taXRlbXM6IHN0cmV0Y2g7Cn0KLl8xcnNsOHFqNyB7CiAgYWxpZ24taXRlbXM6IGJhc2VsaW5lOwp9Ci5fMXJzbDhxajggewogIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDsKfQouXzFyc2w4cWo5IHsKICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kOwp9Ci5fMXJzbDhxamEgewogIGp1c3RpZnktY29udGVudDogY2VudGVyOwp9Ci5fMXJzbDhxamIgewogIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjsKfQouXzFyc2w4cWpjIHsKICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWFyb3VuZDsKfQouXzFyc2w4cWpkIHsKICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWV2ZW5seTsKfQ==\"}!../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
import "src/style/index.css.ts.vanilla.css!=!../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/style/index.css.ts.vanilla.css\",\"source\":\"#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\"}!../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var InterFont = 'Inter';
export var NunitoFont = 'Nunito';
export var cls_backgroundBlack = '_1j7rp574m';
export var cls_backgroundBlue10 = '_1j7rp574x';
export var cls_backgroundBlue100 = '_1j7rp5756';
export var cls_backgroundBlue20 = '_1j7rp574y';
export var cls_backgroundBlue30 = '_1j7rp574z';
export var cls_backgroundBlue40 = '_1j7rp5750';
export var cls_backgroundBlue50 = '_1j7rp5751';
export var cls_backgroundBlue60 = '_1j7rp5752';
export var cls_backgroundBlue70 = '_1j7rp5753';
export var cls_backgroundBlue80 = '_1j7rp5754';
export var cls_backgroundBlue90 = '_1j7rp5755';
export var cls_backgroundCyan10 = '_1j7rp574n';
export var cls_backgroundCyan100 = '_1j7rp574w';
export var cls_backgroundCyan20 = '_1j7rp574o';
export var cls_backgroundCyan30 = '_1j7rp574p';
export var cls_backgroundCyan40 = '_1j7rp574q';
export var cls_backgroundCyan50 = '_1j7rp574r';
export var cls_backgroundCyan60 = '_1j7rp574s';
export var cls_backgroundCyan70 = '_1j7rp574t';
export var cls_backgroundCyan80 = '_1j7rp574u';
export var cls_backgroundCyan90 = '_1j7rp574v';
export var cls_backgroundGreen1 = '_1j7rp576h';
export var cls_backgroundGreen2 = '_1j7rp576i';
export var cls_backgroundGreen3 = '_1j7rp576j';
export var cls_backgroundGreen4 = '_1j7rp576k';
export var cls_backgroundGreen5 = '_1j7rp576l';
export var cls_backgroundGreen6 = '_1j7rp576m';
export var cls_backgroundGrey100 = '_1j7rp576g';
export var cls_backgroundGrey50 = '_1j7rp576b';
export var cls_backgroundGrey60 = '_1j7rp576c';
export var cls_backgroundGrey70 = '_1j7rp576d';
export var cls_backgroundGrey80 = '_1j7rp576e';
export var cls_backgroundGrey90 = '_1j7rp576f';
export var cls_backgroundMagenta10 = '_1j7rp575r';
export var cls_backgroundMagenta100 = '_1j7rp5760';
export var cls_backgroundMagenta20 = '_1j7rp575s';
export var cls_backgroundMagenta30 = '_1j7rp575t';
export var cls_backgroundMagenta40 = '_1j7rp575u';
export var cls_backgroundMagenta50 = '_1j7rp575v';
export var cls_backgroundMagenta60 = '_1j7rp575w';
export var cls_backgroundMagenta70 = '_1j7rp575x';
export var cls_backgroundMagenta80 = '_1j7rp575y';
export var cls_backgroundMagenta90 = '_1j7rp575z';
export var cls_backgroundOrange10 = '_1j7rp5761';
export var cls_backgroundOrange100 = '_1j7rp576a';
export var cls_backgroundOrange20 = '_1j7rp5762';
export var cls_backgroundOrange30 = '_1j7rp5763';
export var cls_backgroundOrange40 = '_1j7rp5764';
export var cls_backgroundOrange50 = '_1j7rp5765';
export var cls_backgroundOrange60 = '_1j7rp5766';
export var cls_backgroundOrange70 = '_1j7rp5767';
export var cls_backgroundOrange80 = '_1j7rp5768';
export var cls_backgroundOrange90 = '_1j7rp5769';
export var cls_backgroundOrchid10 = '_1j7rp575h';
export var cls_backgroundOrchid100 = '_1j7rp575q';
export var cls_backgroundOrchid20 = '_1j7rp575i';
export var cls_backgroundOrchid30 = '_1j7rp575j';
export var cls_backgroundOrchid40 = '_1j7rp575k';
export var cls_backgroundOrchid50 = '_1j7rp575l';
export var cls_backgroundOrchid60 = '_1j7rp575m';
export var cls_backgroundOrchid70 = '_1j7rp575n';
export var cls_backgroundOrchid80 = '_1j7rp575o';
export var cls_backgroundOrchid90 = '_1j7rp575p';
export var cls_backgroundPurple10 = '_1j7rp5757';
export var cls_backgroundPurple100 = '_1j7rp575g';
export var cls_backgroundPurple20 = '_1j7rp5758';
export var cls_backgroundPurple30 = '_1j7rp5759';
export var cls_backgroundPurple40 = '_1j7rp575a';
export var cls_backgroundPurple50 = '_1j7rp575b';
export var cls_backgroundPurple60 = '_1j7rp575c';
export var cls_backgroundPurple70 = '_1j7rp575d';
export var cls_backgroundPurple80 = '_1j7rp575e';
export var cls_backgroundPurple90 = '_1j7rp575f';
export var cls_backgroundWhite = '_1j7rp574l';
export var cls_bold = '_1j7rp576x';
export var cls_colorBlack = '_1j7rp572q';
export var cls_colorBlue10 = '_1j7rp5731';
export var cls_colorBlue100 = '_1j7rp573a';
export var cls_colorBlue20 = '_1j7rp5732';
export var cls_colorBlue30 = '_1j7rp5733';
export var cls_colorBlue40 = '_1j7rp5734';
export var cls_colorBlue50 = '_1j7rp5735';
export var cls_colorBlue60 = '_1j7rp5736';
export var cls_colorBlue70 = '_1j7rp5737';
export var cls_colorBlue80 = '_1j7rp5738';
export var cls_colorBlue90 = '_1j7rp5739';
export var cls_colorCyan10 = '_1j7rp572r';
export var cls_colorCyan100 = '_1j7rp5730';
export var cls_colorCyan20 = '_1j7rp572s';
export var cls_colorCyan30 = '_1j7rp572t';
export var cls_colorCyan40 = '_1j7rp572u';
export var cls_colorCyan50 = '_1j7rp572v';
export var cls_colorCyan60 = '_1j7rp572w';
export var cls_colorCyan70 = '_1j7rp572x';
export var cls_colorCyan80 = '_1j7rp572y';
export var cls_colorCyan90 = '_1j7rp572z';
export var cls_colorGreen1 = '_1j7rp576n';
export var cls_colorGreen2 = '_1j7rp576o';
export var cls_colorGreen3 = '_1j7rp576p';
export var cls_colorGreen4 = '_1j7rp576q';
export var cls_colorGreen5 = '_1j7rp576r';
export var cls_colorGreen6 = '_1j7rp576s';
export var cls_colorGrey100 = '_1j7rp574k';
export var cls_colorGrey50 = '_1j7rp574f';
export var cls_colorGrey60 = '_1j7rp574g';
export var cls_colorGrey70 = '_1j7rp574h';
export var cls_colorGrey80 = '_1j7rp574i';
export var cls_colorGrey90 = '_1j7rp574j';
export var cls_colorMagenta10 = '_1j7rp573v';
export var cls_colorMagenta100 = '_1j7rp5744';
export var cls_colorMagenta20 = '_1j7rp573w';
export var cls_colorMagenta30 = '_1j7rp573x';
export var cls_colorMagenta40 = '_1j7rp573y';
export var cls_colorMagenta50 = '_1j7rp573z';
export var cls_colorMagenta60 = '_1j7rp5740';
export var cls_colorMagenta70 = '_1j7rp5741';
export var cls_colorMagenta80 = '_1j7rp5742';
export var cls_colorMagenta90 = '_1j7rp5743';
export var cls_colorOrange10 = '_1j7rp5745';
export var cls_colorOrange100 = '_1j7rp574e';
export var cls_colorOrange20 = '_1j7rp5746';
export var cls_colorOrange30 = '_1j7rp5747';
export var cls_colorOrange40 = '_1j7rp5748';
export var cls_colorOrange50 = '_1j7rp5749';
export var cls_colorOrange60 = '_1j7rp574a';
export var cls_colorOrange70 = '_1j7rp574b';
export var cls_colorOrange80 = '_1j7rp574c';
export var cls_colorOrange90 = '_1j7rp574d';
export var cls_colorOrchid10 = '_1j7rp573l';
export var cls_colorOrchid100 = '_1j7rp573u';
export var cls_colorOrchid20 = '_1j7rp573m';
export var cls_colorOrchid30 = '_1j7rp573n';
export var cls_colorOrchid40 = '_1j7rp573o';
export var cls_colorOrchid50 = '_1j7rp573p';
export var cls_colorOrchid60 = '_1j7rp573q';
export var cls_colorOrchid70 = '_1j7rp573r';
export var cls_colorOrchid80 = '_1j7rp573s';
export var cls_colorOrchid90 = '_1j7rp573t';
export var cls_colorPurple10 = '_1j7rp573b';
export var cls_colorPurple100 = '_1j7rp573k';
export var cls_colorPurple20 = '_1j7rp573c';
export var cls_colorPurple30 = '_1j7rp573d';
export var cls_colorPurple40 = '_1j7rp573e';
export var cls_colorPurple50 = '_1j7rp573f';
export var cls_colorPurple60 = '_1j7rp573g';
export var cls_colorPurple70 = '_1j7rp573h';
export var cls_colorPurple80 = '_1j7rp573i';
export var cls_colorPurple90 = '_1j7rp573j';
export var cls_colorWhite = '_1j7rp572p';
export var cls_cursor_pointer = '_1j7rp576y';
export var cls_display_none = '_1j7rp576v';
export var cls_gap_2p5rem = '_1j7rp577b';
export var cls_gap_5rem = '_1j7rp577a';
export var cls_gap_form = '_1j7rp5775';
export var cls_gap_half_rem = '_1j7rp5778';
export var cls_gap_line = '_1j7rp5776';
export var cls_gap_not_supported = '_1j7rp5774';
export var cls_gap_quarter_rem = '_1j7rp5779';
export var cls_gap_rem = '_1j7rp5777';
export var cls_h1 = '_1j7rp5723';
export var cls_h2 = '_1j7rp5724';
export var cls_h3 = '_1j7rp5725';
export var cls_h4 = '_1j7rp5726';
export var cls_h5 = '_1j7rp5727';
export var cls_h6 = '_1j7rp5728';
export var cls_h7 = '_1j7rp5729';
export var cls_h8 = '_1j7rp572a';
export var cls_h9 = '_1j7rp572b';
export var cls_p1b = '_1j7rp572j';
export var cls_p1r = '_1j7rp572c';
export var cls_p2b = '_1j7rp572k';
export var cls_p2r = '_1j7rp572d';
export var cls_p3b = '_1j7rp572l';
export var cls_p3r = '_1j7rp572e';
export var cls_p4b = '_1j7rp572m';
export var cls_p4r = '_1j7rp572f';
export var cls_p5b = '_1j7rp572n';
export var cls_p5r = '_1j7rp572g';
export var cls_p6b = '_1j7rp572o';
export var cls_p6r = '_1j7rp572h';
export var cls_p7r = '_1j7rp572i';
export var cls_rotate_180deg = '_1j7rp577d';
export var cls_rotate_270deg = '_1j7rp577e';
export var cls_rotate_90deg = '_1j7rp577c';
export var cls_tableNumber = '_1j7rp576u';
export var cls_text_align_center = '_1j7rp5772';
export var cls_text_align_left = '_1j7rp5771';
export var cls_text_align_right = '_1j7rp5773';
export var cls_text_decoration_line_through = '_1j7rp5770';
export var cls_visibility_hidden = '_1j7rp576z';
export var cls_width_100_percent = '_1j7rp576w';
export var cls_wrap = '_1j7rp576t';
export var vars = {fs:'var(--_1j7rp570)',white:'var(--_1j7rp571)',black:'var(--_1j7rp572)',cyan10:'var(--_1j7rp573)',cyan20:'var(--_1j7rp574)',cyan30:'var(--_1j7rp575)',cyan40:'var(--_1j7rp576)',cyan50:'var(--_1j7rp577)',cyan60:'var(--_1j7rp578)',cyan70:'var(--_1j7rp579)',cyan80:'var(--_1j7rp57a)',cyan90:'var(--_1j7rp57b)',cyan100:'var(--_1j7rp57c)',blue10:'var(--_1j7rp57d)',blue20:'var(--_1j7rp57e)',blue30:'var(--_1j7rp57f)',blue40:'var(--_1j7rp57g)',blue50:'var(--_1j7rp57h)',blue60:'var(--_1j7rp57i)',blue70:'var(--_1j7rp57j)',blue80:'var(--_1j7rp57k)',blue90:'var(--_1j7rp57l)',blue100:'var(--_1j7rp57m)',purple10:'var(--_1j7rp57n)',purple20:'var(--_1j7rp57o)',purple30:'var(--_1j7rp57p)',purple40:'var(--_1j7rp57q)',purple50:'var(--_1j7rp57r)',purple60:'var(--_1j7rp57s)',purple70:'var(--_1j7rp57t)',purple80:'var(--_1j7rp57u)',purple90:'var(--_1j7rp57v)',purple100:'var(--_1j7rp57w)',orchid10:'var(--_1j7rp57x)',orchid20:'var(--_1j7rp57y)',orchid30:'var(--_1j7rp57z)',orchid40:'var(--_1j7rp5710)',orchid50:'var(--_1j7rp5711)',orchid60:'var(--_1j7rp5712)',orchid70:'var(--_1j7rp5713)',orchid80:'var(--_1j7rp5714)',orchid90:'var(--_1j7rp5715)',orchid100:'var(--_1j7rp5716)',magenta10:'var(--_1j7rp5717)',magenta20:'var(--_1j7rp5718)',magenta30:'var(--_1j7rp5719)',magenta40:'var(--_1j7rp571a)',magenta50:'var(--_1j7rp571b)',magenta60:'var(--_1j7rp571c)',magenta70:'var(--_1j7rp571d)',magenta80:'var(--_1j7rp571e)',magenta90:'var(--_1j7rp571f)',magenta100:'var(--_1j7rp571g)',orange10:'var(--_1j7rp571h)',orange20:'var(--_1j7rp571i)',orange30:'var(--_1j7rp571j)',orange40:'var(--_1j7rp571k)',orange50:'var(--_1j7rp571l)',orange60:'var(--_1j7rp571m)',orange70:'var(--_1j7rp571n)',orange80:'var(--_1j7rp571o)',orange90:'var(--_1j7rp571p)',orange100:'var(--_1j7rp571q)',grey50:'var(--_1j7rp571r)',grey60:'var(--_1j7rp571s)',grey70:'var(--_1j7rp571t)',grey80:'var(--_1j7rp571u)',grey90:'var(--_1j7rp571v)',grey100:'var(--_1j7rp571w)',green1:'var(--_1j7rp571x)',green2:'var(--_1j7rp571y)',green3:'var(--_1j7rp571z)',green4:'var(--_1j7rp5720)',green5:'var(--_1j7rp5721)',green6:'var(--_1j7rp5722)'};